"use client";

import { ShoppingCart } from "lucide-react";
import { useCart } from "@/lib/cart/cart-context";

type Props = { locale: "da" | "en"; className?: string };

/**
 * Header-cart-knap. Åbner drawer-popup'en i stedet for at navigere til /kurv,
 * så brugeren bliver på samme side mens de gennemgår kurven.
 */
export function CartButton({ locale, className }: Props) {
  const { itemCount, isHydrated, openCart } = useCart();

  return (
    <button
      type="button"
      onClick={openCart}
      aria-label={locale === "en" ? "Open cart" : "Åbn kurv"}
      className={`relative inline-flex items-center justify-center gap-1.5 ${className ?? ""}`}
    >
      <ShoppingCart size={18} strokeWidth={2} />
      {isHydrated && itemCount > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[var(--color-primary-700)] text-white text-[10px] font-bold flex items-center justify-center"
          aria-label={locale === "en" ? `${itemCount} items` : `${itemCount} varer`}
        >
          {itemCount}
        </span>
      )}
    </button>
  );
}
